import { colors } from '@material-ui/core';
import React, { useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import SubMenuCom from './Menus/SubMenuCom';
import { Link } from 'react-router-dom';
import { setPermissions, unsetPermissions, setUsrePermissions, setUsrePermissions_as_Null } from "../../Redux/Actions/permission_action"
// let SERVER_URL = process.env.REACT_APP_API_URL;
// let BASE_URL = process.env.REACT_APP_APP_URL;
// let token = JSON.parse(localStorage.getItem('key'));

import Select from "react-select";
const userId = localStorage.getItem('userId');
function PermissionCom() {

    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));

    const dispatch = useDispatch()
    const [it, setIt] = useState([])
    const [att, setAtt] = useState([])
    const [emp, setEmp] = useState([])
    const [header, setHeader] = useState([]);
    const [hrmenu, setHrmenu] = useState([])
    const [header_check, setHeader_Check] = useState([])
    const [mainMenu, setMainMenu] = useState([])
    const [msg, setMsg] = useState('')
    const [msg_class, setMsg_class] = useState('');
    const inputRoleRef = useRef(null);
    const inputUserRef = useRef(null);
    const [err_role, setErr_role] = useState('');
    const [err_user, setErr_user] = useState('');
    const [system_role, setSystem_role] = useState('');
    const [user, setUser] = useState('');
    const [userList, setUserList] = useState([]);
    const [system_type_permission, setSystem_type_permission] = useState(1)
    function permissionType(type) {
        setSystem_type_permission(type)
        // setSystem_role('')
        setUser('')
        setErr_user('')
        setErr_role('')
        //  setHeader([])
        dispatch(setUsrePermissions_as_Null())
    }
    const getUserRoleBased = (syatemRoleId) => {
        dispatch(setUsrePermissions_as_Null())
        setSystem_role(syatemRoleId)
         if (syatemRoleId === "" || syatemRoleId === null || syatemRoleId === undefined) {
            setUserList([]);
            return false;
         }
        fetch(SERVER_URL + `api/common/getUser_By_SystemRole`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                system_role_id: syatemRoleId
            })
        }).then(res => res.json()).then(data => {
            if (data.status == true) {
                const options = data?.result?.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setUserList(options)


            } else {
                setUserList([])
            }
        })
    }



    const handlePermission = (user_id) => {
        dispatch(setUsrePermissions_as_Null())
         if (user_id === "" || user_id === null || user_id === undefined) {
            return false;
         }
        setUser(user_id)
        dispatch(setUsrePermissions(user_id, system_type_permission))
    }
    let get_per = useSelector((state) => state)

    useEffect(() => {
        getMainMenu()
    }, [get_per?.Permission?.permissions])



    const [user_permission, setUser_permission] = useState([]);
    const handleCheckboxChange = (value, checked) => {
        if (checked) {
            dispatch(setPermissions(value, checked))
        } else {
            dispatch(unsetPermissions(value, checked))
        }
        setHeader(get_per.Permission.permissions)
    }





    const getMainMenu = (appication_id) => {
        fetch(SERVER_URL + `api/menu/getmenu`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                application_id: appication_id
            }),
        }).then((res) => res.json()).then((data) => {
            if (data.status == true) {
                setMainMenu(data?.results)
            }
        })
    }
    const checkboxesRef = useRef([]);
    function reset_permission() {
        // setSystem_role('');
        setUser('')
        setHeader([])
        uncheckAll()
    }
    const uncheckAll = () => {
        checkboxesRef.current.forEach((checkbox) => {
            checkbox.checked = false;
        });
    };
    const Update_permissions = () => {
        fetch(SERVER_URL + `api/permission/set-permission`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                userId: user,
                permissionType: system_type_permission,
                accessPermissionHive: get_per?.Permission?.permissions?.join(','),
                accessPermissionConnect: get_per?.Permission?.permissions?.join(','),
                requestedBy: userId
            })
        }).then(res => res.json()).then(data => {
            if (data.status == true) {
                
                setMsg(data.msg)
                setMsg_class('green')
                setTimeout(function () {
                    setMsg('')
                }, 1000);
                setSystem_role('')
                setUserList([])
                // systemRoleOptions([])
            } else {
                setMsg('Something went wrong')
                setMsg_class('red')
            }
            dispatch(setUsrePermissions_as_Null())
            reset_permission('')

        })
    }

    const HandleSubmit = (event) => {
        event.preventDefault();
        setErr_user('')
        if (system_role == '') {
            setErr_role('red')
            inputRoleRef.current.focus();
            return false;
        }
        else if (user === "" || user === null || user === undefined) {
            setErr_user('red')
            inputUserRef.current.focus();
        } else {
            Update_permissions()
        }
    }



    const update_Permission = () => {
        fetch(SERVER_URL + `api/menu/getmenu`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                userId: user,
                user_permission: user_permission,
                updateBy: ''
            }),
        }).then((res) => res.json()).then((data) => {
            if (data.status == true) {
                setMainMenu(data?.results)
            }
        })

    }
    function HandleType(type_id) {
        setSystem_type_permission(type_id)
        // alert(type_id)
    }



    const systemRoleOptions = [                               
                                { value: "1", label: "Employee" },
                                { value: "2", label: "Hr Executive" },
                                { value: "3", label: "Manager" },
                                { value: "4", label: "Senior Executive" },
                                { value: "5", label: "Executive" },
                                { value: "6", label: "Leadership" },
                                { value: "7", label: "Finance Manager" },
                                { value: "8", label: "Project Manager" },
                                { value: "9", label: "IT Manager" },
                                { value: "10", label: "Team Lead" }
                            ];
    return (
        <>
            <div className="page-header">
                <h1>Permission</h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                        <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span> Permission
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                <div className="dash_white_box2">
                    <form >
                        <div className="row mb30">
                            <div className="col-md-3">
                                <label className="col-form-label">Permission Type :</label>
                                <select onChange={(e) => HandleType(e.target.value)} value={system_type_permission} name="Permission_type" className="form-select">
                                    <option value="1">QBS Connect</option>
                                    {/* <option value="2">QBS Hive</option> */}
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="col-form-label">System Role :</label>
                                <Select 
                                ref={inputRoleRef}
                                options={systemRoleOptions}

                        value={systemRoleOptions.find(opt => opt.value === system_role) || null}
                        onChange={(selectedOption) =>{  
                            setUser('')  
                        getUserRoleBased(selectedOption ? selectedOption.value : "")}

                        }
                                isClearable
                                isSearchable
                                placeholder="Select System Role"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base) => ({
                                    ...base,
                                    borderColor: err_role || base.borderColor
                                    })
                                }}
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="col-form-label">Employee Name :</label>
                               <Select 
                               ref={inputUserRef}
                                options={userList}
                                value={userList.find(u => u.value === user) || null}
                                onChange={(selected) => {
                                    setUser(selected ? selected.value : null) 
                                    handlePermission(selected?selected.value:null)
                                    
                                }}
                                isClearable
                                isSearchable
                                placeholder="Select Employee Name"
                                styles={{
                                    control: (base) => ({
                                     ...base,
                                     borderColor: err_user || base.borderColor
                                    })
                                }}
                               />
                            </div>
                        </div>


                        <ul className="timeline_wrp" style={{ display: system_type_permission == 1 ? "block" : "none" }}>
                            <li>
                                <div className="timeline_icon1"></div>
                                <div className="timeline_icon"></div>
                                <div className="timeline_text">
                                    <div className="form-blk">
                                        <div className="form-label formlabel_ttl">Header</div>
                                        <div className="form-input row">
                                            {
                                                mainMenu?.map((item, ind) => {
                                                    return <div key={item.menu_id} className="col-md-4">
                                                        <div className="form-check formcheck1 mt00 mb05">
                                                            <input checked={get_per?.Permission?.permissions?.includes(item.menu_id?.toString())} className="form-check-input" type="checkbox" value={item.menu_id} onChange={(e) => handleCheckboxChange(e.target.value, e.target.checked)} />
                                                            <label className="form-check-label" htmlFor="dashboard">
                                                                {item.menu_name}
                                                            </label>
                                                        </div>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </li>

                            {
                                mainMenu?.map((item, ind) => (
                                    (item.menu_id !== 1 ? (<li key={ind}>
                                        <div className="timeline_icon"></div>
                                        <div className="timeline_text">

                                            <div className="form-blk">
                                                <div className="form-label formlabel_ttl">{item.menu_name}</div>
                                                <div className="form-input row">

                                                    <SubMenuCom menu_id={item.menu_id} />

                                                </div>
                                            </div>
                                        </div>
                                    </li>) : null)
                                ))
                            }


                        </ul>




                        <ul className="timeline_wrp" style={{ display: system_type_permission == 2 ? "block" : "none" }}>
                            <li>
                                <div className="timeline_icon1"></div>
                                <div className="timeline_icon"></div>
                                <div className="timeline_text">
                                    <div className="form-blk">
                                        <div className="form-label formlabel_ttl">Menu</div>

                                        <div className="form-input row">
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input checked={get_per?.Permission?.permissions?.includes('1')} className="form-check-input" type="checkbox" value="1" onChange={(e) => handleCheckboxChange(e.target.value, e.target.checked)} />
                                                    <label className="form-check-label" htmlFor="dashboard">
                                                        Dashboard
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li>
                                <div className="timeline_icon"></div>
                                <div className="timeline_text">
                                    <div className="form-blk">
                                        <div className="form-label formlabel_ttl">Resources</div>
                                        <div className="form-input row">
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" name="consultant[]" id="addConsultant" value="1" />
                                                    <label className="form-check-label" htmlFor="addConsultant">Add Resources </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" name="consultant[]" id="EditConsultant" value="2" />
                                                    <label className="form-check-label" htmlFor="EditConsultant">Edit Resources </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" name="consultant[]" id="viewdetailconsultant" value="3" />
                                                    <label className="form-check-label" htmlFor="viewdetailconsultant">View Details </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" name="consultant[]" id="viewIniormationconsultant" value="4" />
                                                    <label className="form-check-label" htmlFor="viewIniormationconsultant">View Information</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" name="consultant[]" id="viewcontractconsultant" value="5" />
                                                    <label className="form-check-label" htmlFor="viewcontractconsultant">View Contract(s)</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li>
                                <div className="timeline_icon"></div>
                                <div className="timeline_text">
                                    <div className="form-blk">
                                        <div className="form-label formlabel_ttl">Assignment Resources</div>
                                        <div className="form-input row">
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" name="allocation[]" id="allocationgrid" value="1" />
                                                    <label className="form-check-label" htmlFor="allocationgrid">Assignment Grid</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" name="allocation[]" id="setupunavailability" value="2" />
                                                    <label className="form-check-label" htmlFor="setupunavailability">Setup Unavailability </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" name="allocation[]" id="assignresources" value="3" />
                                                    <label className="form-check-label" htmlFor="assignresources">Assign Resources </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" name="allocation[]" id="allocationfilter" value="4" />
                                                    <label className="form-check-label" htmlFor="allocationfilter">Assignment Filter </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="timeline_icon"></div>
                                <div className="timeline_text">
                                    <div className="form-blk">
                                        <div className="form-label formlabel_ttl">Administration</div>
                                        <div className="form-input row">
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" id="roles" name="administration[]" value="1" />
                                                    <label className="form-check-label" htmlFor="roles">Roles</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" id="subroles" name="administration[]" value="2" />
                                                    <label className="form-check-label" htmlFor="subroles">Sub Roles </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" id="doccategory" name="administration[]" value="3" />
                                                    <label className="form-check-label" htmlFor="doccategory">Doc Categories </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" id="subject" name="administration[]" value="4" />
                                                    <label className="form-check-label" htmlFor="subject">Subjects </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" id="grades" name="administration[]" value="5" />
                                                    <label className="form-check-label" htmlFor="grades">Grades </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" id="service" name="administration[]" value="6" />
                                                    <label className="form-check-label" htmlFor="service">Services </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="timeline_icon"></div>
                                <div className="timeline_text">
                                    <div className="form-blk">
                                        <div className="form-label formlabel_ttl">Management</div>
                                        <div className="form-input row">
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" id="vendormanagement" name="management[]" value="1" />
                                                    <label className="form-check-label" htmlFor="vendormanagement">Resource Management</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" id="manageskills" name="management[]" value="2" />
                                                    <label className="form-check-label" htmlFor="manageskills">Manage Skills </label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-check formcheck1 mt00 mb05">
                                                    <input className="form-check-input" type="checkbox" id="user" name="management[]" value="3" />
                                                    <label className="form-check-label" htmlFor="user">User Permissions</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="text-end mb20">
                            <button className="float-end btn_6 ml10">Cancel</button>
                            <button className="float-end btn_5" onClick={HandleSubmit}>Save</button>
                            <div className="float-end mr08 mt10" style={{ color: msg_class }}>{msg}</div>
                        </div>
                    </form>
                </div>

            </div>
        </>
    )
}

export default PermissionCom
